import { AgGridReact } from 'ag-grid-react';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import {
  getCampaignList,
  getCampaignMemberStatus,
  getGenericMasterFilteredListByKey,
  getGridDataByModuleKey,
  getLeadList,
  getleadTotalCount,
} from '../../redux/selector';
import {
  fetchDataAndUpdateStore,
  fetchLeadsAndAppendToModule,
  fetchRemainingData,
} from '../../redux/actions';
import Select from 'react-select';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { campaignInputData, handleGridSearch, leadInputData } from '../../shared/constants';
import CustomPagination from './grid/customPagination';
import { set } from 'date-fns';
import { Link } from 'react-router-dom';

const ChildLead = ({ module, localData, hasUpdateLeadPermission }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedRowsPopup, setSelectedRowsPopup] = useState([]);
  const gridRef = useRef();
  const [selectedOptions, setSelectedOptions] = useState({});
  const [deleteData, setDeleteData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [filteredLeadList, setFilteredLeadList] = useState([]);
  const localGridRef = useRef();

  const gridApiRef = useRef(null);
  const [localLeadInputPayload, setLocalLeadInputPayload] = useState({
    ...leadInputData,
    module: module,
    moduleId: localData?.id,
  });
  // Pagination state
  const [totalCount, setTotalCount] = useState(0);
  const gridData = useSelector(getGridDataByModuleKey('leads'));
  const [searchText, setSearchText] = useState(gridData?.inputPayload?.searchText || '');
  const [isFocused, setIsFocused] = useState(false);

  let hasInfoLeadPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.leadmenu;

  if (userUIControlPermission) {
    hasInfoLeadPermission = userUIControlPermission?.leadinfoscreen
      ? userUIControlPermission.leadinfoscreen.canView
      : true;
  }

  // Get total record count from Redux
  const leadTotalCount = useSelector(getleadTotalCount);
  // We'll use leadTotalCount for total records rather than filteredLeadList.length.
  const totalRecords = leadTotalCount || 0;

  // When grid is ready, capture the API and update pagination info
  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  const onSelectionChanged = (event) => {
    setSelectedRows(event.api.getSelectedRows()); // Get all selected rows
  };

  const onSelectionChangedPopup = (event) => {
    setSelectedRowsPopup(event.api.getSelectedRows()); // Get all selected rows
  };

  const [leadListAll, setLeadListAll] = useState(null);

  useEffect(() => {
    fetchCampaign();
  }, [localLeadInputPayload.pageNumber, localLeadInputPayload?.pageSize, localData?.id]);

  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));

  const campaignList = useSelector(getCampaignList);

  const fetchCampaign = async () => {
    if (!localData?.id) return;
    if (searchText) {
      localLeadInputPayload.searchText = searchText;
    } else {
      localLeadInputPayload.searchText = null;
    }
    gridApiRef.current?.showLoadingOverlay();
    setLoading(true);

    try {
      const res = await apiServices.getLeadList(localLeadInputPayload);
      const leads = res.data.leads || [];

      setLeadListAll(leads);
      setTotalCount(res.data.totalCount || 0);

      if (leads.length === 0) {
        gridApiRef.current?.showNoRowsOverlay();
      } else {
        gridApiRef.current?.hideOverlay();
      }
    } catch (error) {
      console.error('Error fetching campaigns', error);
      gridApiRef.current?.showNoRowsOverlay();
    } finally {
      setLoading(false);
    }
  };

  const clearSearch = async () => {
    setSearchText('');

    const payload = {
      ...localLeadInputPayload,
      pageNumber: 1,
      searchText: '',
    };

    try {
      gridApiRef.current?.showLoadingOverlay(); // ✅ Show loading before fetch
      setLoading(true);
      const res = await apiServices.getLeadList(payload);
      const leads = res.data.leads || [];

      setLeadListAll(leads);
      setTotalCount(res.data.totalCount || 0);

      if (leads.length === 0) {
        gridApiRef.current?.showNoRowsOverlay();
      } else {
        gridApiRef.current?.hideOverlay();
      }
    } catch (error) {
      console.error('Search Clear Error', error);
      gridApiRef.current?.showNoRowsOverlay();
    } finally {
      setLoading(false);
    }
  };

  const campaignColumnDefs = [
    {
      headerName: 'Full Name',
      field: 'fullName',
      width: 150,
      filter: 'agSetColumnFilter',
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    { headerName: 'Company Name', field: 'companyName', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Email', field: 'email', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Phone', field: 'phone', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Owner', field: 'owner', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Email Opt Out', field: 'emailOptOut', width: 150, filter: 'agSetColumnFilter' },
  ];

  const localLeadColumnDefs = [
    {
      headerName: 'Actions',
      headerCheckboxSelection: true,
      checkboxSelection: true,
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <div className="action-menu">
            {hasUpdateLeadPermission && (
              <>
                <img
                  src="/assets/images/edit.png"
                  className="action-img1"
                  onClick={() => handleClickEdit(paramsValue)}
                  alt="Edit Lead"
                  title="Edit Lead"
                ></img>
                <img
                  src="/assets/images/trash.png"
                  className="action-img2"
                  onClick={() => openPopup3(paramsValue)}
                  alt="UnAssign Lead"
                  title="UnAssign Lead"
                ></img>
              </>
            )}
          </div>
        );
      },
      maxWidth: 120,
      sortable: false,
      filter: false,
      pinned: 'left',
    },
    {
      headerName: 'Lead Name',
      field: 'fullName',
      width: 150,
      filter: 'agSetColumnFilter',
      cellRenderer: (params) => {
        if (!params.value || params.node.group) return params.value;

        // Conditionally make the name clickable if permission exists
        return hasInfoLeadPermission ? (
          <Link
            to={`/leads/viewLead?id=${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
            state={params.data}
            style={{ fontWeight: '600' }}
          >
            {params.value}
          </Link>
        ) : (
          <span style={{ fontWeight: '600' }}>{params.value}</span>
        );
      },
    },
    { headerName: 'Company', field: 'companyName', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Email', field: 'email', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Lead Source', field: 'leadSource', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Phone', field: 'phone', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Member Status', field: 'memberStatus', width: 150, filter: 'agSetColumnFilter' },
    // { headerName: "Owner", field: "owner", width: 150, filter: "agSetColumnFilter" },
  ];
  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        {
          statusPanel: () => (
            <CustomPagination
              inputPayload={localLeadInputPayload}
              setInputPayload={setLocalLeadInputPayload}
              totalCount={totalCount}
            />
          ),
          align: 'center',
        },
      ],
    };
  }, [localLeadInputPayload, totalCount]);

  const onSearch = (searchValue) => {
    handleGridSearch({
      searchValue,
      apiMethod: apiServices.getLeadList,
      gridApiRef,
      inputPayload: localLeadInputPayload,
      setData: setLeadListAll,
      setTotalCount,
      setLoading,
    });
  };

  const onFilterTextBoxChangedLocal = useCallback(() => {
    localGridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmedText = searchText.trim();
      if (trimmedText) {
        onSearch(trimmedText);
      } else {
        clearSearch(); // <--- this ensures it resets with empty searchText
      }
    }
  };

  const frameworkComponents = {
    checkboxRenderer: (props) => {
      const handleChange = (e) => {
        const isSelected = props.node.isSelected();
        props.node.setSelected(!isSelected); // Toggle the selection state of the row
      };

      return <input type="checkbox" checked={props.node.isSelected()} onChange={handleChange} />;
    },
  };

  const handleOpen = () => {
    setIsOpen(true);
    fetchCampaign();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const openPopup2 = () => {
    setShowPopup2(true);
  };

  const closePopup2 = () => {
    setShowPopup2(false);
  };
  // Function to close the third popup
  const closePopup3 = () => {
    setShowPopup3(false);
  };

  // Function to open the third popup
  const openPopup3 = (data) => {
    setShowPopup3(true);
    setDeleteData(data);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'memberStatusId') {
      setFormData({
        ...formData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    }
  };

  useEffect(() => {
    const plannedOption = memberStatus?.find((option) => option.displayName === 'Planned');

    if (plannedOption) {
      setSelectedOptions((prevState) => ({
        ...prevState,
        memberStatusId: plannedOption.id,
      }));

      setFormData((prevState) => ({
        ...prevState,
        memberStatus: plannedOption.id,
        memberStatusId: plannedOption.displayName,
      }));
    }
  }, [memberStatus, showPopup2]);

  const handleSubmit = async (formData) => {
    const hasMissingEmail = selectedRowsPopup.some((row) => !row.email);
    if (hasMissingEmail) {
      toast.error('One of the selected lead does not have email');
      return;
    }

    const hasEmailOptOut = selectedRowsPopup.some((row) => row.emailOptOut);
    if (hasEmailOptOut) {
      toast.error('One of the selected lead has opted out of emails');
      return;
    }

    setLoading(true);
    const selectedIds = selectedRowsPopup.map((row) => row.id);

    if (formData.type === 'edit') {
      const data = {
        ...formData,
        moduleId: formData.id,
        campaignId: localData.id,
        module: 'Lead',
      };

      await apiServices
        .updateCampaignByModule(data)
        .then((response) => {
          if (response.status === 200) {
            setShowPopup2(false);
            dispatch(
              fetchLeadsAndAppendToModule({
                moduleName: module,
                id: localData?.id,
              })
            );

            toast.success('Lead Updated Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error updating leads:', error);
          toast.error('Failed to update leads.', { position: 'top-right' });
        });
    } else {
      const data = {
        ...formData,
        leadId: selectedIds,
        campaignId: [localData.id],
      };

      await apiServices
        .addCampaignFromLead(data)
        .then((response) => {
          if (response.status === 200) {
            setSelectedRowsPopup([]);
            handleClose();
            dispatch(
              fetchLeadsAndAppendToModule({
                moduleName: module,
                id: localData?.id,
              })
            );

            toast.success('Lead Added Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error adding leads:', error);
          toast.error('Failed to add leads.', { position: 'top-right' });
        });
    }

    // }

    setLoading(false);
    setFormData([]);
  };

  const handleClickDeleteLead = (paramsValue) => {
    setLoading(true);
    const selectedIds = selectedRows?.map((row) => row.id);
    // Creating the desired JSON object
    const data = {
      campaignId: localData.id,
      module: 'Lead',
      moduleId: selectedRows?.length > 0 ? selectedIds : [paramsValue?.id],
    };
    console.log('Data==>>', data);
    apiServices
      .deleteCampaignByModule(data)
      .then((response) => {
        if (response.status === 200) {
          setShowPopup3(false);
          setSelectedRows([]);
          dispatch(
            fetchLeadsAndAppendToModule({
              moduleName: module,
              id: localData?.id,
            })
          );
          setLoading(false);
          toast.success('Lead UnAssigned Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while UnAssigning lead:', error);
        setLoading(false);
      });
  };
  const handleClickEdit = (data) => {
    setShowPopup2(true);
    setEditData({
      ...data,
      type: 'edit',
    });
  };

  return (
    <div className="row" id="campainview">
      <div className="col-12 col-sm-12 col-md-12">
        <div className="infoBox">
          <div className="addlead-header">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/images/leadInfo.svg" alt="" />
              Leads({localData?.lead?.length})
            </label>

            <span></span>

            <button type="button" className="btn btn-outline-primary attBtn" onClick={handleOpen}>
              Add Leads
            </button>
          </div>
          <div className="leadcontent">
            <>
              <div className="row">
                <div className="col-12 col-md-12">
                  <div id="view_leadtable">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div className="heading_item">
                        <input
                          className="form-control"
                          id="filter-text-box"
                          type="Text"
                          placeholder="Search in Leads..."
                          onInput={onFilterTextBoxChangedLocal}
                        />
                      </div>
                      {selectedRows?.length > 0 && (
                        <div className="heading_item">
                          <button
                            className="btn btn-primary"
                            type="button"
                            onClick={handleClickDeleteLead}
                          >
                            UnAssign
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="cutome_ag_theme " style={{ marginTop: '1rem' }} id="withFilter">
                      <div className="ag-theme-balham tbl_height">
                        <AgGridReact
                          rowData={localData?.lead}
                          columnDefs={localLeadColumnDefs}
                          defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            resizable: true,
                          }}
                          suppressRowClickSelection={true}
                          rowSelection="multiple"
                          sideBar={sideBar}
                          onSelectionChanged={onSelectionChanged}
                          alwaysShowVerticalScroll={true}
                          ref={localGridRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
          {isOpen && (
            <div id="genricPopup">
              <div className="popup-backdrop">
                <div className="popup fullWidthPopup">
                  {/* Popup Header */}
                  <div className="popup-header">
                    <h4 className="popup-title">
                      Add Leads to Campaign : {localData?.campaignName}
                    </h4>
                    <button className="custom-btn-close" onClick={handleClose}></button>
                  </div>
                  {/* Popup Body */}
                  <div className="popup-body">
                    <div className="popupbody_header">
                      <div className="hd_leftview">
                        <div className="heading_item" id="contct_search">
                          <div className="search-container">
                            <input
                              type="text"
                              id="filter-text-box"
                              className={`form-control${searchText ? ' focused' : ''}`}
                              placeholder="Search..."
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                              onKeyDown={handleKeyDown}
                            />

                            {searchText && (
                              <span className="clear-btn" onClick={clearSearch}>
                                &times;
                              </span>
                            )}
                            <button
                              className="contactsearch"
                              type="button"
                              onClick={() => onSearch(searchText)}
                              onFocus={() => setIsFocused(true)}
                              onBlur={() => setIsFocused(false)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="flx_heding view_fnt" id="action_dropdown">
                          <>
                            <label htmlFor="memberStatusId" style={{ width: '100px' }}>
                              Member Status:
                            </label>
                            <Select
                              id="memberStatus"
                              value={selectedOptions.memberStatus}
                              placeholder={formData.memberStatusId}
                              onChange={(selectedOption) =>
                                handleChange(selectedOption, 'memberStatusId')
                              }
                              options={memberStatus?.map((data) => ({
                                value: data.id,
                                label: data.displayName,
                              }))}
                              styles={{
                                container: (base) => ({
                                  ...base,
                                  width: '200px',
                                  minHeight: '30px',
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: '9999',
                                  height: '200px',
                                  overflow: 'auto',
                                  color: '#000',
                                }),
                                control: (base) => ({
                                  ...base,
                                  borderRadius: '6px',
                                }),
                              }}
                            />
                          </>
                        </div>
                      </div>
                      <div className="hd_rightview" id="update_campaign">
                        <div className="flx_heding view_fnt">
                          <label>
                            Total Records: <span>{totalCount}</span>
                          </label>
                        </div>

                        <span className="separator"></span>
                        <div className="flx_heding">
                          <button
                            className="add-btn"
                            type="button"
                            onClick={() => handleSubmit(formData)}
                            disabled={!selectedRowsPopup.length > 0 || loading}
                          >
                            {selectedRowsPopup.length > 0 && loading && (
                              <>
                                {' '}
                                <div
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                ></div>
                              </>
                            )}
                            {selectedRowsPopup.length > 0 && loading
                              ? 'Loading...'
                              : 'Add to Campaign'}
                          </button>
                        </div>

                        {/* Popup 2 Overlay */}
                      </div>
                    </div>
                    <div className="cutome_ag_theme" style={{ marginTop: '1rem' }}>
                      <div
                        className="ag-theme-balham tbl_height"
                        style={{
                          height: 'calc(100vh - 320px)',
                          width: '100%',
                        }}
                      >
                        <AgGridReact
                          rowData={leadListAll}
                          columnDefs={campaignColumnDefs}
                          suppressRowClickSelection={true}
                          defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            resizable: true,
                          }}
                          sideBar={sideBar}
                          rowSelection="multiple"
                          onSelectionChanged={onSelectionChangedPopup}
                          ref={gridRef}
                          statusBar={statusBar}
                          onGridReady={onGridReady}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showPopup2 && (
            <div id="genricPopup">
              <div className="popup-backdrop">
                <div className="popup-overlay">
                  <div className="popup" style={{ width: '50%' }}>
                    {/* Popup Header */}
                    <div className="popup-header">
                      <h4 className="popup-title">Update Campaign Member Status</h4>
                      <button className="custom-btn-close" onClick={closePopup2}></button>
                    </div>

                    {/* Popup Body */}
                    <div className="popup-body" style={{ color: '#000', zIndex: '1050' }}>
                      <div className="row">
                        <div className="col-12 col-md-12">
                          <div className="input-container">
                            <>
                              <label htmlFor="memberStatusId">Member Status</label>
                              <Select
                                value={selectedOptions.memberStatusId}
                                placeholder={editData.memberStatus || 'Select Status'}
                                onChange={(selectedOption) =>
                                  handleChange(selectedOption, 'memberStatusId')
                                }
                                options={memberStatus?.map((data) => ({
                                  value: data.id,
                                  label: data.displayName,
                                }))}
                                menuPortalTarget={document.body}
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: '100%',
                                    zIndex: '9999',
                                  }),
                                  control: (base, state) => ({
                                    ...base,
                                    borderRadius: '5px',
                                    border: state.isFocused
                                      ? '2px solid #365397'
                                      : '1px solid #ccc',
                                    boxShadow: state.isFocused ? '0 0 5px #365397' : 'none', // Focus shadow
                                    transition: 'border-color 0.3s, box-shadow 0.3s',
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: '99999', // Dropdown z-index
                                    maxHeight: '150px', // Limit dropdown height
                                    overflowY: 'auto', // Scroll if items exceed height
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: '99999', // Rendered dropdown above everything
                                  }),
                                  option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isFocused
                                      ? '#365397' // Hover background
                                      : state.isSelected
                                        ? 'rgba(54, 83, 151, 0.2)' // Selected background
                                        : '#fff', // Default background
                                    color: state.isFocused || state.isSelected ? '#fff' : '#000', // Text color
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s, color 0.3s',
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    padding: '5px',
                                    borderRadius: '3px',
                                  }),
                                }}
                              />
                            </>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Popup Footer */}
                    <div className="popup-footer" id="unassign-popup">
                      <button className="cancel-lead ld-btn" onClick={closePopup2}>
                        Cancel
                      </button>
                      <button
                        className="save-lead ld-btn"
                        onClick={() => handleSubmit({ ...formData, id: editData.id, type: 'edit' })}
                      >
                        Save
                      </button>

                      {/* Popup 3 Overlay */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showPopup3 && (
            <div id="unassign-popup">
              <div className="popup-overlay">
                <div
                  className="popup"
                  style={{
                    width: '50%',
                    textAlign: 'center',
                    padding: '20px',
                    zIndex: '9999',
                    background: 'white',
                  }}
                >
                  {/* Popup Body */}
                  <div className="popup-body">
                    <div className="row">
                      <div className="col-12 col-md-12">
                        <div className="unassign-txt">
                          <p>
                            Unassign {deleteData.firstName} {deleteData.middleName}{' '}
                            {deleteData.lastName} from {localData.campaignName}?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Popup Footer */}
                  <div className="unassign-footer">
                    <button className="btn btn-outline-primary" onClick={closePopup3}>
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleClickDeleteLead(deleteData)}
                      disabled={loading}
                    >
                      {loading && (
                        <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                      )}
                      {loading ? 'Loading...' : 'Unassign'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChildLead;
